export default __webpack_public_path__ + "static/icon-charts-fe4c3b1fa2fbdb226a88e507b6943e4c.svg";